<template>
  <div id="modalProfileLogo">
    <ModalBoxDialogTour
      width="360px"
      :showModal.sync="show"
      :positionTop="positionTop"
      :positionLeft="positionLeft"
      @hideModal="mixpanelEvent('onlineview_close_logo_setting_tour_document'), hideModal()"
    >
      <template slot="content">
        <div>
          <div class="content-tour">
            <img :src="tourImageUrl" class="p-eak" />
            <div class="suggestion-header">
              <h3 v-html="$t('Document_Tour.Profile_Logo.Head')"></h3>
              <p class="mt-1">
                {{ $t("Document_Tour.Profile_Logo.Description_1") }}
              </p>
              <p class="mt-1">
                {{ $t("Document_Tour.Profile_Logo.Description_2") }}
              </p>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="mt-3 border-top d-flex justify-content-end">
          <buttonStyle
            width="120px"
            height="32px"
            :text="$t('Document_Tour.Profile_Logo.Seting_btn')"
            styleButton="primary"
            theme="purple"
            class="mt-3 btnSettingLogo"
            @click="mixpanelEvent('onlineview_go_to_logo_setting_tour_document'), GoToSetting()"
          />
        </div>
      </template>
    </ModalBoxDialogTour>
  </div>
</template>

<script>
import { DocumentTourStatus } from "@/enums/enums";
import { analytics, event } from "../../../service/analytics/analytics";
import { GetStaticFileServiceUrl } from "@/helper/uploadHelper";
export default {
  props: {
    emi: {
      type: String,
      default: "",
    },
  },
  components: { ModalBoxDialogTour: () => import("./ModalBoxDialogTour") },
  computed: {
    getPackageRecurringDetailLoadingStatus() {
      return this.$store.getters.GetPackageRecurringDetailLoadingStatus;
    },
    packageDetailLoadingStatus() {
      return this.$store.getters.GetPackageDetailLoadingStatus;
    },
  },
  data() {
    return {
      show: true,
      positionTop: "0px",
      positionLeft: "0px",
      screenWidth: 0,
      resizeListener: null,
      tourImageUrl: GetStaticFileServiceUrl("peakengine/Content/Image/UserTour/p-eak.png"),
      screenWidth: 0,
      resizeListener: null,
    };
  },
  watch: {
    show(newValue, oldValue) {
      this.hideModal(newValue);
    },
  },
  mounted() {
    this.UpdateScreenWidth();
    this.OnScreenResize();
    this.SetDialogPosition();
  },
  updated() {
    this.$nextTick(() => {
      this.SetDialogPosition();
    });
  },
  watch: {
    positionTop: {
      immediate: true,
      handler(newValue) {
        if (newValue === "0px") {
          this.SetDialogPosition();
          const checkPosition = () => {
            if (this.positionTop === "0px") {
              this.SetDialogPosition();
              setTimeout(checkPosition, 500);
            }
          };
          checkPosition();
        }
      },
    },
    screenWidth(newValue) {
      if (newValue < 1000) {
        this.$router
          .replace({
            name: "receipt",
            query: {
              ...this.$route.query,
              tourEdit: DocumentTourStatus.Hide.toString(),
              tourLogo: DocumentTourStatus.Hide.toString(),
              tourSignature: DocumentTourStatus.Hide.toString(),
            },
          })
          .catch(() => {});
      }
    },
  },
  methods: {
    OnScreenResize() {
      this.resizeListener = () => {
        this.UpdateScreenWidth();
      };
      window.addEventListener("resize", this.resizeListener);
    },
    UpdateScreenWidth() {
      this.SetDialogPosition();
      this.screenWidth = window.innerWidth;
    },
    hideModal() {
      this.$router
        .replace({ name: "receipt", query: { ...this.$route.query, tourLogo: DocumentTourStatus.Hide.toString() } })
        .catch(() => {});
    },
    SetDialogPosition() {
      const element = document.getElementById(`merchantLogo`);
      if (element) {
        let diffTopPosition = 0;
        let diffLeftPosition = 0;
        if (this.screenWidth > 1580) {
          diffTopPosition = 160;
          diffLeftPosition = 41;
        } else if (this.screenWidth > 1250 && this.screenWidth < 1580) {
          diffTopPosition = 255;
          diffLeftPosition = 110;
        } else if (this.screenWidth < 1250) {
          diffTopPosition = 255;
          diffLeftPosition = 140;
        }
        this.positionTop = `${element.offsetTop + diffTopPosition}px`;
        this.positionLeft = `${element.offsetLeft + diffLeftPosition}px`;
      }
    },
    DestroyResizeListener() {
      window.removeEventListener("resize", this.resizeListener);
    },
    GoToSetting() {
      window.open(
        `${process.env.VUE_APP_PeakAccount}setting/logoStamp?emi=${
          this.emi
        }&tourSetting=${DocumentTourStatus.Show.toString()}`,
        "_blank_profile"
      );
    },
    mixpanelEvent(menu) {
      analytics.emitEvent(event.in_app[menu], { language: this.$i18n.locale });
    },
  },
  beforeDestroy() {
    this.DestroyResizeListener();
  },
};
</script>

<style lang="scss" scoped>
#modalProfileLogo {
  p,
  h3 {
    font-size: 18px !important;
    line-height: 1.2 !important;
  }
  .content-tour {
    display: flex;
    align-items: flex-start;
    align-self: stretch;
  }
  .p-eak {
    width: 48px;
    height: 48px;
  }
  .suggestion-header {
    display: flex;
    flex-direction: column;
    align-self: start;
    gap: 6px;
  }
  .text-blue {
    color: $blue_default;
  }
  .btnSettingLogo {
    white-space: nowrap;
  }
}
</style>
